import React from 'react';

import Box from '../Box'
import { Wrapper } from "./ACommonStyles";
import { getPcsUrls } from "./AHelpers";

export default props => {
	const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);
	return (
		<section className="container">
			<Wrapper className="row" pcs={pcs}>
				<div className="col-xs-12 col-md-3">
					<Box {...props} id="b1" type="BPhotoOnTop" settings={props.settings.b1} classes="" />
				</div>
				<div className="col-xs-12 col-md-3">
					<Box {...props} id="b2" type="BPhotoOnTop" settings={props.settings.b2} classes="" />
				</div>
				<div className="col-xs-12 col-md-3">
					<Box {...props} id="b3" type="BPhotoOnTop" settings={props.settings.b3} classes="" />
				</div>
				<div className="col-xs-12 col-md-3">
					<Box {...props} id="b4" type="BPhotoOnTop" settings={props.settings.b4} classes="" />
				</div>
			</Wrapper>
		</section>
	);
}